var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsHlinkLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 43,
    viewBox: "0 0 186 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14776 40.9904L11.9268 30.9061H23.1589L26.1696 40.9904H35.6068L23.5063 1.64429H11.9268L0 40.9904H9.14776ZM19.3952 15.9255L21.8269 24.2611H13.2002L15.5161 15.9255C15.8977 14.5635 16.2585 12.9504 16.6109 11.3745C16.8468 10.3201 17.0788 9.28242 17.3109 8.34776H17.4267C17.5207 8.72614 17.6177 9.11987 17.7172 9.52396C18.2312 11.61 18.8132 13.9723 19.3952 15.9255Z",
    fill: "#2A569D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0276 31.8387C37.4014 33.0628 41.049 34.2869 44.8123 34.2869C48.8651 34.2869 51.0073 32.5965 51.0073 30.0317C51.0073 27.5835 49.1546 26.1845 44.4649 24.4941C37.9804 22.2207 33.7539 18.6067 33.7539 12.8943C33.7539 6.19085 39.312 1.06128 48.5756 1.06128C52.9758 1.06128 56.218 1.99393 58.5339 3.04316L56.5654 10.2129C55.0022 9.45512 52.2231 8.3476 48.4019 8.3476C44.5807 8.3476 42.728 10.0963 42.728 12.1365C42.728 14.643 44.9281 15.7505 49.9651 17.6741C56.8549 20.2389 60.0971 23.8529 60.0971 29.3905C60.0971 35.9773 55.0601 42.1561 44.2912 41.6315C41.4542 41.5149 39.4278 40.932 37.3435 39.2999L35.0276 31.8387Z",
    fill: "#2A569D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5763 16.7998V1.64429H61.6602V41.0487H70.5763V24.5525V16.7998Z",
    fill: "#2A569D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9979 16.7998V1.64429H83.1396V41.0487H91.9979V24.5525V16.7998Z",
    fill: "#2A569D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3394 18.0822H66.7549V24.9022H86.4978V18.0822H78.2185H74.3394Z",
    fill: "#2A569D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2012 2.09747H102.252V37.1734H119.029V41.4268H97.2012V2.09747Z",
    fill: "#4192D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.021 8.39033C126.053 8.39033 127.33 6.99195 127.272 5.24398C127.272 3.43774 126.053 2.03937 124.137 2.03937C122.28 2.03937 120.944 3.43774 120.944 5.24398C120.944 6.99195 122.221 8.39033 124.021 8.39033ZM121.583 13.2265V41.4853H126.692V13.2265H121.583Z",
    fill: "#4192D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.943 20.8592C129.943 17.946 129.885 15.5571 129.711 13.2264H134.239L134.529 17.8877H134.645C136.039 15.2075 139.29 12.5855 143.934 12.5855C147.823 12.5855 153.861 14.9161 153.861 24.5882V41.4853H148.752V25.1709C148.752 20.6262 147.069 16.8389 142.25 16.8389C138.883 16.8389 136.271 19.2278 135.4 22.0828C135.168 22.7237 135.052 23.5977 135.052 24.4717V41.4853H129.943V20.8592Z",
    fill: "#4192D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.045 26.1613H162.161C162.858 25.1708 163.845 23.9472 164.658 22.9567L172.959 13.2263H179.113L168.257 24.8212L180.622 41.4852H174.41L164.716 27.9093L162.103 30.8226V41.4269H157.053V0H162.103V26.1613H162.045Z",
    fill: "#4192D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.393 39.9254H182.304V39.4021H180V39.9254H180.911V42.9346H181.393V39.9254ZM185.196 39.4674L184.393 42.0187L183.696 39.4674H182.893V42.9999H183.375V40.1216L184.286 42.9999H184.607L185.518 40.1216V42.9999H186V39.4674H185.196Z",
    fill: "#4190C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsHlinkLogoDark);
export default __webpack_public_path__ + "static/media/ASHlink_Logo_Dark.4e8a9b1bf44b10c61cf0a7dd7c388f02.svg";
export { ForwardRef as ReactComponent };